import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FirstConfigurationComponent } from './components/first-configuration/first-configuration.component';
import { StepsModule } from 'primeng/steps';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { Select } from 'primeng/select';
import { ReactiveFormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { PasswordModule } from 'primeng/password';
import { PickListModule } from 'primeng/picklist';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '../../shared/shared.module';
import { ProgressSpinnerModule } from 'primeng/progressspinner';

@NgModule({
  declarations: [
    FirstConfigurationComponent,
    
  ],
  imports: [
    CommonModule,
    StepsModule,
    ButtonModule,
    CheckboxModule,
    Select,
    ReactiveFormsModule,
    InputTextModule,
    PasswordModule,
    PickListModule, 
    TranslateModule,
    SharedModule,
    ProgressSpinnerModule
  ]
})
export class FirstConfigurationModule { }
